<button 
  [class]="getButtonClass()"
  [disabled]="disabled"
  (click)="onClick()"
  [attr.aria-label]="ariaLabel || buttonText">
  
  <span *ngIf="buttonText">{{ buttonText }}</span>
  
  <!-- Icon from image source -->
  <img *ngIf="iconSrc && !iconSvg" [src]="iconSrc" [alt]="buttonText + ' icon'" />
  
  <!-- Icon from SVG string (sanitized) -->
  <div *ngIf="safeSvg && !iconSrc" [innerHTML]="safeSvg"></div>
  
  <!-- Count badge -->
  <span *ngIf="showCount && count > 0" class="count-badge">
    {{ count }}
  </span>
</button>
